<template>
  <div class="PricesSectionList">
    <PricesHome
      :title="homeTitle"
      :description="homeDesc"
      :ctaText="ctaText"
      :width="width"
      :height="height"
      :span="span"
      @activeChange="activeChange"
    />

    <PricesSection
      v-for="(section, index) in sections"
      :key="key(index)"
      :section="section"
      :mockText="mockText"
      :sectionId="index"
      :ref="`section-${index}`"
      @activeChange="activeChange"
    />
  </div>
</template>

<script>
import PricesSection from "@/components/PricesSection";
import PricesHome from "@/components/PricesHome";

export default {
  name: "PricesSectionList",
  props: {
    sections: Array,
    mockText: String,
    homeTitle: String,
    homeDesc: String,
    ctaText: String,
    width: Number,
    height: Number,
    span: String,
  },
  methods: {
    key(index) {
      return `PricesSection-${index}`;
    },
    activeChange(val) {
      this.$emit("activeChange", val);
    },
  },
  components: {
    PricesSection,
    PricesHome,
  },
  data: () => ({}),
};
</script>

<style lang="stylus" scoped>
@import './PricesSectionList.styl';
</style>
